(function () {

	var UNIT_MILES = true;   // set to false if your locator uses km
	var PAN_MAX_RESULTS = 200;

	function haversine(a, b) {
	  var R = UNIT_MILES ? 3958.8 : 6371;
	  var toRad = Math.PI / 180;
	  var dLat = (b.lat() - a.lat()) * toRad, dLng = (b.lng() - a.lng()) * toRad;
	  var x = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
			  Math.cos(a.lat() * toRad) * Math.cos(b.lat() * toRad) *
			  Math.sin(dLng / 2) * Math.sin(dLng / 2);
	  return 2 * R * Math.asin(Math.sqrt(x));
	}

	if (window.jQuery && !window.__wplPrefilter) {
	  window.__wplPrefilter = true;
	  jQuery.ajaxPrefilter(function (options) {
		var p = window.wplPanParams;
		if (!p || typeof options.data !== 'string' || options.data.indexOf('store_search') === -1) { return; }
		options.data = options.data
		  .replace(/(^|&)search_radius=[^&]*/, '$1search_radius=' + p.radius)
		  .replace(/(^|&)max_results=[^&]*/, '$1max_results=' + p.max);
		window.wplPanParams = null;   // apply to one request only
	  });
	}


  function bind(m) {
	  var timer, userDragged = false, dragSeq = 0, locked = false;

	  // Instance-level wrappers: ignore the plugin's refit while a pan-search runs
	  var orig = {};
	  ['fitBounds', 'setCenter', 'setZoom', 'panTo', 'panBy'].forEach(function (name) {
		orig[name] = m[name];
		m[name] = function () {
		  if (locked) { return; }
		  return orig[name].apply(m, arguments);
		};
	  });

	  function panSearch() {
		var input = document.querySelector('#wpsl-search-input');
		var btn = document.querySelector('#wpsl-search-btn');
		if (!input || !btn) { return; }
		if (btn.disabled) { timer = setTimeout(panSearch, 300); return; }  // wait for the previous search

		var view = { c: m.getCenter(), z: m.getZoom() };
		var seq = dragSeq;
		locked = true;
		input.value = view.c.lat().toFixed(6) + ',' + view.c.lng().toFixed(6);

		var b = m.getBounds();
		if (b) {
			var radius = Math.ceil(haversine(view.c, b.getNorthEast()));
			window.wplPanParams = { radius: radius, max: PAN_MAX_RESULTS };
		}

		btn.click();

		var waited = 0, sawDisabled = false;
		(function poll() {
		  waited += 100;
		  if (btn.disabled) { sawDisabled = true; }
		  var done = (sawDisabled && !btn.disabled) || waited > 6000 || (!sawDisabled && waited > 1500);
		  if (!done) { return setTimeout(poll, 100); }
		  setTimeout(function () {
			locked = false;
			// Safety net: if the view changed anyway and the user hasn't dragged again, put it back
			if (seq === dragSeq) {
			  orig.setZoom.call(m, view.z);
			  orig.setCenter.call(m, view.c);
			}
		  }, 200);
		})();
	  }

	  m.addListener('dragstart', function () { userDragged = true; dragSeq++; });
	  m.addListener('idle', function () {
		if (!userDragged) { return; }       // ignore moves the plugin makes itself
		userDragged = false;
		clearTimeout(timer);
		timer = setTimeout(panSearch, 600);
	  });
	}

  function capture(obj) {
    if (obj.__wplBound) { return; }
    obj.__wplBound = true;
    window.wplCapturedMap = obj;
    bind(obj);
  }

  function register() {
    wp.hooks.addFilter('wpslMapOptions', 'uavionix/capture-map', function (opts) {
      var E = google.maps.event;
      if (!E.__wplWrapped) {
        E.__wplWrapped = true;
        ['addListener', 'addListenerOnce'].forEach(function (name) {
          var orig = E[name];
          E[name] = function (obj) {
            if (obj && typeof obj.getCenter === 'function' && typeof obj.getDiv === 'function') {
              capture(obj);
            }
            return orig.apply(this, arguments);
          };
        });
      }
      return opts;
    });
  }

  // Wait for WordPress's hooks library, which may load after the head
  var tries = 0;
  (function wait() {
    if (window.wp && wp.hooks && wp.hooks.addFilter) { return register(); }
    if (tries++ < 400) { setTimeout(wait, 25); }
  })();
})();
